import React, {Component} from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";

import Loader from "../../Loader/Loader";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";

import classnames from "classnames";
import styles from "./DataBox.scss";

export default class Nominee extends Component {

  constructor(props) {
    super(props);
    this.state = {
      nominees: undefined,
      datum: undefined,
      data_schema: undefined,

      showConfirmModal: false,
      showEditModal: false
    }
  }

  componentDidMount() {
    this.updateTable()
  }

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/admin/getallnominees/")
      .then(res => {
        this.setState({
          nominees: res.data
        });
      })
      .catch(e => console.log(e));
  };

  getNewDataSchema = () => {
    var data = { ...this.state.nominees[0] };
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === '_id' || ent[0] === 'declaration') {
        return null;
      } else if (typeof ent[1] === "string") {
        data_schema[ent[0]] = "";
        return null;
      } else if (typeof ent[1] === "boolean") {
        data_schema[ent[0]] = false;
        return null;
      } else if (typeof ent[1] === "number") {
        data_schema[ent[0]] = 0;
        return null;
      } else {
        data_schema[ent[0]] = "";
        return null;
      }
    });
    this.showEditModal(data_schema);
  };

  getDataSchema = data => {
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === 'declaration') {
        return null;
      } else {
        data_schema[ent[0]] = ent[1];
      }
      return null;
    });
    this.showEditModal(data_schema);
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  date = (a,b) => {
    // Sort profles in decreasing order of update date
    if (a.update_date > b.update_date)
      return -1;
    if (a.update_date < b.update_date)
      return 1;
    return 0;
  }

  deleteData(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/deletenominee/", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  updateOrAdd(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateoraddnominee", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  render() {
    if ( !this.state.nominees) {

      return <Loader/>;
    }
    else {

      return(
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
          />

          <div className={classnames("table-responsive", styles.table)}>
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <th>First Name </th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>LinkedIn</th>
                  <th>Description </th>
                  <th>Job Applied</th>
                  <th>Sectors</th>
                  <th>Education</th>
                  <th>Experience</th>
                  <th>Phone</th>
                  <th>Skills</th>
                  <th>Nominator</th>
                  <th>Nomination Date</th>
                  <th>Updated By Nominee</th>
                  <th>Authorized Invite</th>
                  <th>Archive</th>
                  <th className="textCenter">Edit</th>
                  <th className="textCenter">Delete</th>
                </tr>
              </thead>
              <tbody>
                {this.state.nominees.sort(this.date).map((row, i) => {
                  return(
                    <tr key={i}>
                    <td>{row.first_name} </td>
                    <td>{row.last_name} </td>
                    <td>{row.email} </td>
                    <td>{row.linkedin}</td>
                    <td>{row.description}</td>
                    <td>{row.job_applied}</td>
                    <td>{row.sectors.map(sector => sector.label).join(", ")}</td>
                    <td>{row.education}</td>
                    <td>{row.experience ? row.experience.label: "N/A"}</td>
                    <td>{row.phone}</td>
                    <td>{row.skills.map(sk => sk.label).join(", ")}</td>
                    <td>{row.nominator}</td>
                    <td>{row.nomination_date}</td>
                    <td>{row.update_date}</td>
                    <td>{row.auth_invite === true ? "Authenticated" : "Not Authenticated"}</td>
                    <td>{row.archive === true ? "Hidden": "Displayed"}</td>
                    <td className="textCenter">
                    <FontAwesomeIcon
                    className={styles.cursor}
                    onClick={() => this.getDataSchema(row)}
                    style={{ color: "#323643" }}
                    icon={faEdit}
                    />
                    </td>
                    <td className="textCenter">
                    <FontAwesomeIcon
                    className={styles.cursor}
                    onClick={() => this.showConfirmModal(row)}
                    style={{ color: "#323643" }}
                    icon={faTrash}
                    />
                    </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Nominee.js